import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import useFormatNumber from '../../hooks/useFormatNumber';

const Option = ({ optionProps, highlighted, selected, option }) => {
	const formatNumber = useFormatNumber();

	const buttonProps = {
		...optionProps,
		value: option.value
	};

	const className = setClassNames([
		'option',
		'text',
		selected && 'is-selected',
		highlighted && 'is-highlighted'
	]);

	const classLabel = setClassNames([
		highlighted && 'text-primary text-decoration-underline'
	]);

	return (
		<li
			role="menuitem"
			data-index={option.index}
			data-value={escape(option.value)}
			key={option.value}
		>
			<button type="button" className={className} {...buttonProps}>
				<span>
					<span className={classLabel}>{option.label}</span>&nbsp;
					{(option.count === 0 || option.count) && (
						<small>{formatNumber(option.count)}</small>
					)}
				</span>
			</button>
		</li>
	);
};

Option.propTypes = {
	option: PropTypes.shape({
		label: PropTypes.string.isRequired,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		disabled: PropTypes.bool,
		index: PropTypes.number,
		count: PropTypes.number
	}).isRequired,
	highlighted: PropTypes.bool.isRequired,
	selected: PropTypes.bool.isRequired,
	optionProps: PropTypes.shape({
		tabIndex: PropTypes.string.isRequired,
		onMouseDown: PropTypes.func.isRequired
	}).isRequired
};

export default memo(Option);
